import { eventsKeys } from '../constants';
import send from './send';

export default () => {
  send(eventsKeys.SIGN_UP_EMAIL);
};
